import { StationPageWrapper } from '@app/core/routing/StationPageWrapper';
import { LoggerStreamPage } from './screens/stream/LoggerStreamPage';

export function LoggerStreamAdapterPage() {
  return (
    <StationPageWrapper>
      <LoggerStreamPage />
    </StationPageWrapper>
  );
}
